module.exports = __webpack_public_path__ + "fonts/Gilroy-ThinItalic.72bca972.woff";